import { GetStaticPaths } from 'next'

import DocsPage from '~/components/DocsPage/DocsPage'
import { DocsPageProps, DocsTemplate } from '~/components/DocsPage/types'
import { getFlattenedHeadings } from '~/lib/docs/docs'
import { getDesktopDocs } from '~/server'
import { getLayoutProps } from '~/lib/layout'

export const getStaticPaths: GetStaticPaths = async () => {
  const docs = await getDesktopDocs()
  const headings = getFlattenedHeadings(docs.headings)
  const headingIds = headings.map((heading) => heading.id)

  // Add the root path (/docs/app/) and all possible section (/docs/app/{section})
  const paths = ['', ...headingIds].map((section) => ({
    params: { section: [section] },
  }))

  return {
    paths,
    fallback: false,
  }
}

export const getStaticProps = async ({ params }: { params: { section: [string | undefined] } }) => {
  const { code, headings } = await getDesktopDocs()

  let section: string | null = null

  if (params?.section && params?.section[0]) {
    const paramsSection = params?.section[0] ?? ''
    const headingIds = getFlattenedHeadings(headings).map((heading) => heading.id)

    if (headingIds.includes(paramsSection ?? '')) {
      section = paramsSection
    }
  }

  return {
    props: {
      code,
      headings,
      section,
      layoutProps: getLayoutProps(),
    },
  }
}

const CLIDocs: React.FC<DocsPageProps & { redirectUrl: string }> = ({ redirectUrl, ...props }) => {
  return <DocsPage {...props} template={DocsTemplate.APP} />
}

export default CLIDocs
